// removed by extract-text-webpack-plugin
module.exports = {"footer":"_2nhzBA1RlNKOVN_nNggXzW","links":"_1_O8IaVfK6gXqH5Zxy3EdP","footerCopyright":"_2-WgL-99TbCXf4jZwKKvOL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.scss
// module id = 1267
// module chunks = 1